import { createFileRoute } from "@tanstack/react-router";
import { SignUpPage } from "@/pages/signup/ui/signup-page";

export const Route = createFileRoute("/auth/signup")({
  component: SignUpPage,
});
